module.exports = "https://trybtryb-legacy.web.app/img/email-capture.4092b022.svg";